import { render } from "./StudentDashboard.vue?vue&type=template&id=3c3a1d1e&lang=true"
import script from "./StudentDashboard.vue?vue&type=script&lang=js"
export * from "./StudentDashboard.vue?vue&type=script&lang=js"

import "./StudentDashboard.vue?vue&type=style&index=0&id=3c3a1d1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__